import { jsxs as m, jsx as e, Fragment as x } from "react/jsx-runtime";
import { aS as d, T as n, d as p, aT as $, aU as b } from "../../../vendor-Dd6qj6gJ.js";
import { LoadMoreItem as B } from "../LoadMoreItem/index.js";
import { SelectEmptyState as S } from "../SelectEmptyState/index.js";
import { SelectItem as h } from "../SelectItem/index.js";
import '../../../assets/index51.css';const u = "_listBox_1sxzd_1", y = {
  listBox: u
};
function z({
  items: s,
  isLoading: t,
  onLoadMore: o,
  hasMore: a,
  isVirtualized: l,
  ...i
}) {
  const f = !!o && a, r = /* @__PURE__ */ m(
    d,
    {
      ...i,
      className: p(y.listBox),
      renderEmptyState: () => /* @__PURE__ */ e(S, { isLoading: t }),
      children: [
        /* @__PURE__ */ e(n, { items: s, children: (c) => /* @__PURE__ */ e(h, { item: c, id: c.id }) }),
        f && /* @__PURE__ */ e(B, { onLoadMore: o, isLoading: t })
      ]
    }
  );
  return l ? /* @__PURE__ */ e($, { layout: b, children: r }) : /* @__PURE__ */ e(x, { children: r });
}
export {
  z as SelectListBox
};
